module.exports = __webpack_public_path__ + "img/horizontal_3_1_7016.88dfcdb7.png";